import { useContext } from "react"
import { UploadContext } from "./indexUpload";

export const  useUpload = () =>{
    const context = useContext(UploadContext);

    return context;
}